import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import LiveClock from '@/components/live-clock/live-clock.vue'
import Filters from '@/components/filters/filters.vue'
import FiltersSelect from '@/components/filters-select/filters-select.vue'
import SearchRegionOrders from '@/pages/region-orders/components/search-region-orders/search-region-orders.vue'
import ConfirmModal from '@/components/modals/confirm-modal/confirm-modal.vue'
import IcPrintColor from '@/assets/svg/ic-print-color.svg?inline'
import IcCity from '@/assets/svg/ic-city.svg?inline'
import IcCityArea from '@/assets/svg/ic-city-area.svg?inline'
import IcArea from '@/assets/svg/ic-area.svg?inline'
import IcManufatureActive from '@/assets/svg/ic-manufature-active.svg?inline'
import IcRefresh from '@/assets/svg/ic-refresh.svg?inline'
import { sharedPages, superUsers, managersPages, topManagersPages } from '@/const'

export default {
  name: 'Header',
  components: {
    LiveClock,
    Filters,
    FiltersSelect,
    SearchRegionOrders,
    ConfirmModal,
    IcPrintColor,
    IcCity,
    IcCityArea,
    IcArea,
    IcManufatureActive,
    IcRefresh
  },
  static() {
    return {
      superUsers,
      managersPages,
      topManagersPages
    }
  },
  computed: {
    ...mapState({
      user: state => state.users.user,
      cities: state => state.manufactures.cities,
      selectedCity: state => state.manufactures.selectedCity,
      selectedAreas: state => state.manufactures.selectedAreas,
      selectedManufacture: state => state.manufactures.selectedManufacture
    }),
    ...mapGetters({
      areaList: 'manufactures/areaList',
      manufacturesList: 'manufactures/manufacturesList'
    }),
    userAvatarDump() {
      if (this.user) {
        const str = this.user.first_name ? this.user.first_name : this.user.last_name
        if (str) {
          return str.charAt(0).toUpperCase()
        }
      }
      return ''
    },
    isSharedPages() {
      return sharedPages.indexOf(this.$route.name) !== -1
    },
    selectedAreasTitle() {
      if (this.selectedAreas.length) {
        if (this.selectedAreas.length === 1) {
          return this.selectedAreas[0].title
        }
        const restDiv = this.selectedAreas.length % 10
        let areaTxt = ''
        if (restDiv === 1) {
          areaTxt = 'территория'
        } else if (restDiv >= 2 && restDiv <= 4) {
          areaTxt = 'территории'
        } else {
          areaTxt = 'территорий'
        }
        return `${this.selectedAreas.length} ${areaTxt}`
      }
      return 'Не выбрано'
    }
  },
  methods: {
    ...mapActions({
      setSelectedCityAction: 'manufactures/setSelectedCity',
      setSelectedAreas: 'manufactures/setSelectedAreas'
    }),
    ...mapMutations({
      setSelectedManufacture: 'manufactures/SET_SELECTED_MANUFACTURE'
    }),
    onInputCity(city) {
      this.setSelectedCityAction(city)
    },
    onInputAreas(areas) {
      this.setSelectedAreas(areas)
    },
    onInputManufacture(manufacture) {
      this.setSelectedManufacture(manufacture)
    },
    refreshManagesInfo() {
      this.$bus.$emit('refresh-managers-info')
    }
  }
}